import { MasterTranslation } from '@/constants';
import { useGlobalState } from '@/hooks';
import {
  ActionTitle,
  Growable,
  GrowableAction,
  GrowableActionContainer,
  GrowableArrow,
} from './GrowableContent.styles';

interface IGrowableContentProps {
  isGrown: boolean;
  contentHeight?: number;
  showToggle: boolean;
  handleToggle?: () => void;
  children: React.ReactNode;
}

const GrowableContent = ({
  isGrown = true,
  contentHeight,
  showToggle,
  handleToggle,
  children,
}: IGrowableContentProps) => {
  const { t } = useGlobalState();
  const actionTitle = isGrown ? t(MasterTranslation.ViewLess) : t(MasterTranslation.ViewMore);

  return (
    <>
      <Growable contentHeight={contentHeight} isGrown={isGrown} showToggle={showToggle}>
        {children}
      </Growable>
      {showToggle && (
        <GrowableActionContainer isGrown={isGrown}>
          <GrowableAction onClick={handleToggle}>
            <ActionTitle>{actionTitle}</ActionTitle>
            <GrowableArrow isOpen={isGrown} />
          </GrowableAction>
        </GrowableActionContainer>
      )}
    </>
  );
};

export { GrowableContent };
